(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ayunel-faq-contact"] && !Shopify.designMode) return;
  try {
    /* 联系阶梯点击埋点:一页可能有十几份 compact(每题一份,默认 hidden),所以挂一个 document 级委托,不逐份绑。
     幂等锁放在 documentElement 的 JS property 上(不新增 window.__AYUNEL_* 全局,horizon-section-standards §0.10)。 */
  (function () {
    'use strict';
    var de = document.documentElement;
    if (de.__aynFaqContactInit) return;
    de.__aynFaqContactInit = true;

    function track(n, p) {
      try {
        if (window.Shopify && window.Shopify.designMode) return;
        if (typeof window.aynTrack === 'function') window.aynTrack(n, p);
      } catch (e) {}
    }

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || typeof t.closest !== 'function') return;
      var a = t.closest('[data-ayn-faq-contact-link]');
      if (!a) return;
      track('ayn_faq_contact_click', {
        ayn_channel: a.getAttribute('data-ayn-channel') || '',
        ayn_place: a.getAttribute('data-ayn-place') || ''
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ayunel-faq-item"] && !Shopify.designMode) return;
  try {
    /* FAQ 单题的行为:役に立ちましたか 投票 + 展开埋点。
     一页有几十题,所以 document 级委托一份;幂等锁放 documentElement 的 JS property(不新增 window 全局)。
     toggle 事件不冒泡,用捕获阶段在 document 上接。 */
  (function () {
    'use strict';
    var de = document.documentElement;
    if (de.__aynFaqItemInit) return;
    de.__aynFaqItemInit = true;

    var KEY_PREFIX = 'ayn_faq_helpful_';

    function track(n, p) {
      try {
        if (window.Shopify && window.Shopify.designMode) return;
        if (typeof window.aynTrack === 'function') window.aynTrack(n, p);
      } catch (e) {}
    }
    function storeGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
    function storeSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }

    /* moveFocus 只在客人真点了按钮时为 true:被藏的按钮上有焦点,不移就掉回 body(读屏 / 键盘用户找不到自己在哪);
       页面加载时按 sessionStorage 回填不移焦点。容器 aria-live=polite,谢语露出时读屏会念。 */
    function markDone(box, value, moveFocus) {
      var btns = box.querySelector('[data-ayunel-faq-helpful-btns]');
      var thanks = box.querySelector('[data-ayunel-faq-helpful-thanks]');
      var contact = box.querySelector('[data-ayunel-faq-helpful-contact]');
      if (btns) btns.hidden = true;
      if (thanks) thanks.hidden = false;
      if (contact) contact.hidden = value !== 'no';
      if (!moveFocus) return;
      var target = null;
      if (value === 'no' && contact) target = contact.querySelector('a, button');
      if (!target) target = thanks;
      if (!target) return;
      try {
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      } catch (e) {}
    }

    function setup(item) {
      var box = item.querySelector('[data-ayunel-faq-helpful]');
      if (!box || box.__aynInit) return;
      box.__aynInit = true;
      var anchor = item.getAttribute('data-ayn-anchor') || '';
      var done = anchor ? storeGet(KEY_PREFIX + anchor) : null;
      if (done === 'yes' || done === 'no') markDone(box, done);
      box.hidden = false;
    }

    function setupAll(scope) {
      (scope || document).querySelectorAll('[data-ayunel-faq-item]').forEach(setup);
    }

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || typeof t.closest !== 'function') return;
      var btn = t.closest('[data-ayunel-faq-helpful] [data-ayn-value]');
      if (!btn) return;
      var box = btn.closest('[data-ayunel-faq-helpful]');
      var item = btn.closest('[data-ayunel-faq-item]');
      var anchor = item ? (item.getAttribute('data-ayn-anchor') || '') : '';
      var value = btn.getAttribute('data-ayn-value') === 'no' ? 'no' : 'yes';
      markDone(box, value, true);
      if (anchor) storeSet(KEY_PREFIX + anchor, value);
      track('ayn_faq_helpful', { ayn_faq_anchor: anchor, ayn_value: value });
    });

    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d || d.tagName !== 'DETAILS' || !d.open) return;
      var item = d.closest('[data-ayunel-faq-item]');
      if (!item) return;
      track('ayn_faq_open', {
        ayn_faq_anchor: item.getAttribute('data-ayn-anchor') || '',
        ayn_faq_cat: item.getAttribute('data-ayn-cat') || ''
      });
    }, true);

    setupAll();
    document.addEventListener('shopify:section:load', function (e) { setupAll(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ayunel-faq-search"] && !Shopify.designMode) return;
  try {
    /* FAQ 搜索:纯 vanilla,无依赖。索引 = /?sections=ayunel-faq-feed 的 JSON;匹配规则见本文件头注。 */
  (function () {
    'use strict';

    var FEED_URL = '/?sections=ayunel-faq-feed';
    var MAX_ROWS = 20;
    var DEBOUNCE_MS = 150;
    var TRACK_SETTLE_MS = 800;
    var RETRY_AFTER_MS = 30000;
    var IDLE_PRELOAD_MS = 2000;
    /* 対客文案(brand-crm 终审前的草稿;守卫 ⑭ 终审档出来后逐字比对) */
    var MSG_LOADING = '読み込み中…';                                                            /* 加载中 */
    var MSG_NONE = '該当するご質問が見つかりませんでした。別のことばでもお試しください。';                                                     /* 没找到 */
    var MSG_DOWN = '検索は現在ご利用いただけません。カテゴリーからお探しください。';               /* 搜索暂不可用,请从分类找 */
    var MSG_CAT_PREFIX = 'カテゴリー:';                                                        /* 分类: */
    var MSG_CAT_SUFFIX = ' →';
    function msgCount(n) { return n + '件のご質問が見つかりました'; }                                             /* N 条回答 */

    function track(n, p) {
      try {
        if (window.Shopify && window.Shopify.designMode) return;
        if (typeof window.aynTrack === 'function') window.aynTrack(n, p);
      } catch (e) {}
    }

    /* 归一化:索引与查询同一函数 */
    function norm(s) {
      s = String(s == null ? '' : s);
      try { s = s.normalize('NFKC'); } catch (e) {}
      s = s.toLowerCase();
      s = s.replace(/(\d),(?=\d{3}(?!\d))/g, '$1');
      s = s.replace(/[\s　、。,.・\/()（）「」【】]/g, '');
      s = s.replace(/[ァ-ヶ]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 0x60); });
      return s;
    }

    function tokens(q) {
      var s = String(q == null ? '' : q);
      try { s = s.normalize('NFKC'); } catch (e) {}
      return s.split(/[\s　]+/).map(norm).filter(function (t) { return t.length > 0; });
    }

    function redact(q) {
      // 2026-09-22 上线前复审:原来只换掉 '@' 一个字 → 邮箱前后半段、带横杠的电话 / 邮编原样进 GA4。
      // 先 NFKC(全角数字 / 全角横杠转半角)再整段遮:邮箱 / 订单号 / 〒邮编 / 横杠电话 / 7 位以上数字。
      var s = String(q == null ? '' : q);
      try { s = s.normalize('NFKC'); } catch (e) {}
      return s.replace(/\S+@\S+|#?AY\d{3,}|#\d{4,}|\d{2,4}-\d{2,4}-\d{3,4}|〒?\d{3}-\d{4}|\d{7,}/g, '[redacted]').slice(0, 40);
    }

    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }

    function parseFeed(json) {
      var html = json && json['ayunel-faq-feed'];
      if (typeof html !== 'string') throw new Error('feed shape');
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var node = doc.querySelector('script[data-ayunel-faq-feed]');
      if (!node) throw new Error('feed script');
      var data = JSON.parse(node.textContent || '');
      if (!data || data.v !== 1 || !Array.isArray(data.items) || !Array.isArray(data.cats)) throw new Error('feed v');
      return data;
    }

    function buildIndex(data) {
      return {
        items: data.items.map(function (it, i) {
          return {
            i: i,
            q: it.q || '',
            cn: it.cn || '',
            u: it.u || '',
            nq: norm(it.q),
            nal: (Array.isArray(it.al) ? it.al : []).map(norm),
            nt: norm(it.t)
          };
        }),
        cats: data.cats.map(function (c) {
          return { t: c.t || '', u: c.u || '', nk: norm((Array.isArray(c.k) ? c.k : []).join(' ')) };
        })
      };
    }

    function searchItems(index, toks) {
      var out = [];
      for (var i = 0; i < index.items.length; i++) {
        var it = index.items[i];
        var score = 0;
        var ok = true;
        for (var k = 0; k < toks.length; k++) {
          var t = toks[k];
          if (it.nq.indexOf(t) !== -1) continue;
          if (it.nal.some(function (a) { return a.indexOf(t) !== -1; })) { score += 1; continue; }
          if (it.nt.indexOf(t) !== -1) { score += 2; continue; }
          ok = false;
          break;
        }
        if (ok) out.push({ it: it, score: score });
      }
      out.sort(function (a, b) { return a.score - b.score || a.it.i - b.it.i; });
      return out.slice(0, MAX_ROWS).map(function (r) { return r.it; });
    }

    function searchCats(index, toks) {
      return index.cats.filter(function (c) {
        return c.nk.length > 0 && toks.every(function (t) { return c.nk.indexOf(t) !== -1; });
      });
    }

    function init(root) {
      if (!root || root.__aynFaqSearchInit) return;
      root.__aynFaqSearchInit = true;

      var form = root.querySelector('[data-ayunel-faq-search-form]');
      var input = root.querySelector('[data-ayunel-faq-search-input]');
      var clear = root.querySelector('[data-ayunel-faq-search-clear]');
      var status = root.querySelector('[data-ayunel-faq-search-status]');
      var results = root.querySelector('[data-ayunel-faq-search-results]');
      var empty = root.querySelector('[data-ayunel-faq-search-empty]');
      if (!form || !input || !clear || !status || !results || !empty) return;

      var scope = root.getAttribute('data-scope') || '';
      var feedPromise = null;
      var index = null;
      var failedAt = 0;
      var debounceTimer = null;
      var trackTimer = null;
      var lastTracked = '';

      function loadFeed() {
        if (feedPromise) return feedPromise;
        feedPromise = fetch(FEED_URL, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) {
            if (!r.ok) throw new Error('feed ' + r.status);
            return r.json();
          })
          .then(parseFeed)
          .then(function (data) {
            index = buildIndex(data);
            return data;
          })
          .catch(function (e) {
            feedPromise = null;
            failedAt = Date.now();
            throw e;
          });
        return feedPromise;
      }
      root.aynFaqFeed = loadFeed;

      function setStatus(text) { status.textContent = text || ''; }

      function reset() {
        clear.hidden = true;
        setStatus('');
        results.hidden = true;
        results.textContent = '';
        empty.hidden = true;
      }

      function renderRows(rows, cats) {
        results.textContent = '';
        rows.forEach(function (it) {
          var li = el('li', 'ayunel-faq-search__row');
          var a = el('a', 'ayunel-faq-search__link');
          a.href = it.u;
          a.appendChild(el('span', 'ayunel-faq-search__q', it.q));
          if (it.cn) a.appendChild(el('span', 'ayunel-faq-search__pill', it.cn));
          li.appendChild(a);
          results.appendChild(li);
        });
        cats.forEach(function (c) {
          var li = el('li', 'ayunel-faq-search__row ayunel-faq-search__row--cat');
          var a = el('a', 'ayunel-faq-search__link');
          a.href = c.u;
          a.appendChild(el('span', 'ayunel-faq-search__q', MSG_CAT_PREFIX + c.t + MSG_CAT_SUFFIX));
          li.appendChild(a);
          results.appendChild(li);
        });
        results.hidden = results.childElementCount === 0;
      }

      /* n = 问答命中数(ayn_results),nCats = 分类命中数;两者都 0 才算零结果(与页面的「見つかりませんでした」同口径) */
      function scheduleTrack(q, n, nCats) {
        clearTimeout(trackTimer);
        trackTimer = setTimeout(function () {
          var key = q + '|' + n + '|' + nCats;
          if (key === lastTracked) return;
          lastTracked = key;
          track('ayn_faq_search', { ayn_faq_page: scope, ayn_query: redact(q), ayn_results: n });
          if (n === 0 && nCats === 0) track('ayn_faq_zero_result', { ayn_faq_page: scope, ayn_query: redact(q) });
        }, TRACK_SETTLE_MS);
      }

      function run() {
        var q = input.value || '';
        var toks = tokens(q);
        clear.hidden = q.length === 0;
        if (toks.length === 0) { reset(); clear.hidden = q.length === 0; return; }

        if (!index) {
          if (!feedPromise && failedAt && Date.now() - failedAt < RETRY_AFTER_MS) {
            setStatus(MSG_DOWN); results.hidden = true; empty.hidden = true;
            return;
          }
          setStatus(MSG_LOADING);
          loadFeed().then(function () { run(); }).catch(function () {
            setStatus(MSG_DOWN); results.hidden = true; empty.hidden = true;
          });
          return;
        }

        var rows = searchItems(index, toks);
        var cats = searchCats(index, toks);
        renderRows(rows, cats);
        if (rows.length === 0 && cats.length === 0) {
          setStatus(MSG_NONE);
          empty.hidden = false;
        } else {
          setStatus(rows.length > 0 ? msgCount(rows.length) : '');
          empty.hidden = true;
        }
        scheduleTrack(q, rows.length, cats.length);
      }

      function onInput() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(run, DEBOUNCE_MS);
      }

      function preload() { if (!index && !feedPromise) loadFeed().catch(function () {}); }

      input.addEventListener('input', onInput);
      input.addEventListener('focus', preload, { once: true });
      input.addEventListener('pointerdown', preload, { once: true });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && input.value) { input.value = ''; run(); }
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearTimeout(debounceTimer);
        run();
      });
      clear.addEventListener('click', function () {
        input.value = '';
        run();
        input.focus();
      });

      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(preload, { timeout: IDLE_PRELOAD_MS });
      } else {
        setTimeout(preload, IDLE_PRELOAD_MS);
      }

      root.hidden = false;
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-ayunel-faq-search]').forEach(init);
    }

    initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ayunel-nib-until"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!window.customElements || customElements.get('ayunel-nib')) return;
    var iso = /^\d{4}-\d{2}-\d{2}$/;
    function todayJst() {
      try {
        var parts = new Intl.DateTimeFormat('en-US', {
          timeZone: 'Asia/Tokyo',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        }).formatToParts(new Date());
        var get = function (type) {
          for (var i = 0; i < parts.length; i++) if (parts[i].type === type) return parts[i].value;
          return '';
        };
        return get('year') + '-' + get('month') + '-' + get('day');
      } catch (e) {
        return '';
      }
    }
    // 过了末日(日本时间):有 data-swap 换字,没有就移除自己;日期串异常 / 取不到今天 → 不动,以服务端判定为准
    //   换字前先比:字已经对了就不再写 —— 下面自定义元素里的 MutationObserver 会因为这一写再回调一次,不比就死循环。
    function expire(el) {
      var until = el.getAttribute('data-until') || '';
      var today = todayJst();
      if (!iso.test(until) || !iso.test(today) || today <= until) return;
      if (el.hasAttribute('data-swap')) {
        if (el.textContent !== el.getAttribute('data-swap')) el.textContent = el.getAttribute('data-swap');
      } else el.remove();
    }
    function recheckAll() {
      var els = document.querySelectorAll('ayunel-nib');
      for (var i = 0; i < els.length; i++) expire(els[i]);
    }
    customElements.define(
      'ayunel-nib',
      class extends HTMLElement {
        connectedCallback() {
          expire(this);
          // 官方 morph(购物车改数量等)对同标签元素是【原地】改字 / 改属性,不会重新 connect(assets/morph.js walk)——
          //   午夜前发出、午夜后才回来的旧响应能把已撤的数写回去。盯住自己:内容或 data-until / data-swap 一变就再判一次
          //   (Codex 2026-09-22 复审 P0;只会「再撤一次」,不会多显示)。
          if (this.isConnected && !this.__aynNibObs && window.MutationObserver) {
            var self = this;
            this.__aynNibObs = new MutationObserver(function () {
              expire(self);
            });
            this.__aynNibObs.observe(this, {
              childList: true,
              characterData: true,
              subtree: true,
              attributes: true,
              attributeFilter: ['data-until', 'data-swap'],
            });
          }
        }
        disconnectedCallback() {
          if (this.__aynNibObs) {
            this.__aynNibObs.disconnect();
            this.__aynNibObs = null;
          }
        }
      }
    );
    // 浏览器「后退」从缓存恢复页面、或页面开着跨过午夜再切回来时,connectedCallback 不会重跑 → 补判一次
    window.addEventListener('pageshow', recheckAll);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') recheckAll();
    });
    // 页面一直开在前台(不切页、不切标签)跨过日本时间零点:上面几个时机都不触发 → 每到 JST 零点 +1 秒补判一次并排下一次。
    //   (Codex 2026-09-22 复审 P0:购物车开着过末日午夜、超过 Worker 60 分钟宽限再下单 = 显示数 > 实发。)日本无夏令时,固定 +9 小时。
    //   后台标签页里定时器可能被浏览器推迟 —— 切回前台时上面的 visibilitychange 会补判。
    function scheduleJstMidnight() {
      var dayMs = 86400000;
      var jstOffsetMs = 32400000;
      var now = Date.now();
      var nextMidnight = (Math.floor((now + jstOffsetMs) / dayMs) + 1) * dayMs - jstOffsetMs;
      setTimeout(function () {
        recheckAll();
        scheduleJstMidnight();
      }, nextMidnight - now + 1000);
    }
    scheduleJstMidnight();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ayunel-points-redeem"] && !Shopify.designMode) return;
  try {
    /* AYUNEL points redeem — 无外部依赖,纯 vanilla。fail-closed:任何取数失败即禁用兑换按钮。
     ⚠️ PRE-FLIGHT §0.10:section 内 JS 必须用 javascript 标签 而非 <script>(Shopify 自动
     bundle/cache/去重)。代价 = 本块脱离 section DOM、且**不能用 Liquid 变量** —— 所有配置
     一律经 data-* 属性传递(见 section 根元素),初始化改为「DOM ready + MutationObserver」
     (§0.10 明令:禁 setTimeout 兜底链)。 */
(function () {
  'use strict';

  function initPointsRedeem() {
    var root = document.querySelector('.ayunel-points-redeem[data-proxy-base]');
    /* 🔴 2026-09-01 双审 H1:幂等锁改 JS property —— 4.1.4 morph 的 copyAttributes 会把
       SSR 新树上没有的属性从旧节点剥掉(1c479ca:copyAttributes 删属性循环),dataset 锁
       在每次购物车 morph 后失效 → 重复绑监听 → 一次点击多张 POST /create(碰钱)。
       property 只要节点被保留就在;root 另挂 data-skip-node-update(walk:248)保属性本体
       (is-ready 同理受保护)。双层保险。 */
    if (!root || root.__aypInit) return;
    root.__aypInit = true;
    var controller = new AbortController(); /* §0.10:listener 带 cleanup signal,防 morph 累积 */
    var SIG = { signal: controller.signal };

      /* ==== POLICY 常量(【待拍板 P-11】蓝图推荐值;T-10 实测后 PROXY_BASE 若变只改这里) ==== */
      var PROXY_BASE = root.dataset.proxyBase || '/apps/points'; /* 【T-10 待实测占位】 */
      var UNIT = 100;            /* P-11:100pt 単位 */
      var COOLDOWN_MS = 30000;   /* Worker 同客 30s 生成冷却(§7),前端同参 disable */

      /* 错误文案(design-redeem §8.2 方向,含糊化、禁技术词;2026-08-11 brand-crm 终审済)
         中文对照:E_GENERIC=当前积分暂不可用,劳驾稍候片刻再试 / E_CHANGED=可用积分有变动,请重新选择 */
      var E_GENERIC = 'ただいまポイントをご利用いただけません。恐れ入りますが、少し時間をおいてからお試しください。';
      /* 🔴 409 = 后端 cancel_race:`UPDATE … WHERE status='reserved'` 影响 0 行。
         ⚠️ 2026-09-06 双脑复审更正:409 **不等于**「积分已被这单用掉」。`reserved` 变走有三条路 ——
            committed(真的变成了这单折扣)/ released(清扫批已释放、积分早退回余额了)/ late_settled。
            前端拿到 409 分不出是哪种,所以文案**一句去向都不能断言**(上一版说「已作为折扣反映,
            请到订单履历确认」,在 released 时是让客人去找一笔不存在的抵扣)。
         文案 brand-crm 2026-09-06 二次终审:只陈述 409 唯一能确定的事实(那行占位已经不在了),
         用「お預かりを終えており」与 reserved 态的「お預かりしています」咬合成同一套词;
         给两个自查出口(先余额后订单履历 —— 主卡语境下她还没下单,先看订单履历会懵)。
         主卡与救援条**共用同一句**(brand-crm:同一错误两处措辞不同,客人截图问客服会以为是两种问题)。 */
      var E_RACE = '恐れ入ります。入れ違いで、こちらのポイントはすでにお預かりを終えており、取り消しのお手続きができませんでした。ポイントが失われることはございませんので、マイページのポイント残高、またはご注文履歴から、今の状態をご確認いただけます。';  /* 取消未能办理;积分不会消失,可在积分余额或订单履历确认 */

      /* 取消受理了、但积分没回余额时的常驻说明(brand-crm 2026-09-06 定稿)。
         四条路径共用一句,**一句去向都不断言** —— 前端只拿得到 released:false,
         分不出是「已成为订单里用掉的那部分」还是「退回手续还在进行中」,
         所以用「場合と場合」两路并陈:任一条都不说谎,判断权交回客人手上。
         ⚠️ 实装时严禁加回「まもなく」「反映までしばらく」—— 那会把四选二写成四选一。 */
      var M_HOLD = 'ポイント割引の適用を解除いたしました。ポイントは、ご注文でお使いいただいた分となっている場合と、残高にお戻しする手続きが続いている場合がございますので、マイページのポイント残高とご注文履歴から、今の状態をご確認いただけます。';
      /* 跨刷新传递:摘码之后必须刷新才能更新金额,而一刷新提示就没了。
         brand-crm 更想要「不刷新、原地局部重绘」(解释与金额变化同时在场,晚半秒就读起来像事故通知),
         但官方重绘要 import CartLinesUpdateEvent(ES module),本文件是普通 javascript 标签拿不到;
         把整条取消链路改成 module 属于重构,而这是碰钱的链路,不在本次范围(已记 backlog)。
         退方案②:刷新后常驻显示,并守住 brand-crm 的三条硬要求 ——
         **不做 toast(会自己消失)、不做弹窗(她会以为还要再点一次)、不用红色**。 */
      var HOLD_KEY = 'ayn_pts_hold_notice';
      function markHoldNotice() {
        try { sessionStorage.setItem(HOLD_KEY, '1'); } catch (e) { /* 隐私模式等:退化成静默,不拖累主流程 */ }
      }
      function renderHoldNotice() {
        var el = root.querySelector('[data-pts-hold]');
        if (!el) return;
        var hit = false;
        try {
          hit = sessionStorage.getItem(HOLD_KEY) === '1';
          if (hit) sessionStorage.removeItem(HOLD_KEY);
        } catch (e) { return; }
        if (!hit) return;
        el.textContent = M_HOLD;
        el.hidden = false;
      }
      /* 立即跑一次:root 已查到即代表 DOM 就绪;标记只在「上一次取消受理但没退分」后存在。 */
      renderHoldNotice();
      var E_CHANGED = 'ご利用可能なポイントが変わりました。恐れ入りますが、もう一度お選びください。';
      /* 2026-09-01 智鹏拍板「输的不对就要提示」:自动修正不再默不作声。
         三句为【草稿】,上线批次随本卡其余文案一并过 brand-crm 终审。
         中文对照:M_EMPTY=请输入要使用的积分数 / M_UNIT=按100积分为单位调整为N /
                  M_CAP=按可用上限调整为N。 */
      var M_EMPTY = 'ご利用になるポイント数をご入力ください。';
      var L_BUSY = 'お手続き中…'; /* 【草稿】处理中按钮文案(智鹏 2026-09-01「等待要有反馈」) */
      function M_UNIT(v) { return '100ポイント単位でのご利用となるため、' + fmtPt(v) + 'ポイントに調整いたしました。'; }
      function M_CAP(v) { return 'ご利用可能な上限にあわせて' + fmtPt(v) + 'ポイントに調整いたしました。'; }
      /* 🔴 2026-08-26 审查修复 D4:409 active_redemption_exists(上次的码没套上车还活着)
         原先也落 E_CHANGED —— 客户照它说的「もう一度お選び」再提交,还是 409,同一句话
         无限循环。单独映射 + 亮出下方「前回のお手続きを取り消す」按钮才是出路。
         2026-08-26 brand-crm 终审:点名按钮(不写「下のボタン」—— 视线下移先撞到的是
         灰掉的主按钮,文字说取消/按钮说使用会对不上;点名照抄本卡 express 行既有惯例)。
         中文对照:E_ACTIVE=上次的积分手续还保留着。按下方的「取消上次的手续」按钮,即可重新使用。 */
      var E_ACTIVE = '前回のポイントのお手続きが残っています。下の「前回のお手続きを取り消す」を押すと、あらためてご利用いただけます。';
      /* 取消后的等待宣告已于 2026-08-12 废弃(客户剩余积分立即可用,宣告 60 分只会吓走人);
         死常量 CANCEL_WAIT_MS / M_CANCEL_SUFFIX 于 2026-09-01 双审清除,历史见 theme-patches 原档。 */

      var availableCache = null; /* 实时余额缓存(cap 跟车刷新用);null = 初始化未成功 */
      var lastTotalJpy = null;    /* 最新车额(円)。balance 未回时也先记着,回来后用它算 cap(2026-09-01 双审 #1b:初始化竞态) */
      var capReqSeq = 0;          /* /cart.js 响应乱序防护(2026-09-01 双审 #3) */
      var pendingNotice = false;  /* 2026-09-01 智鹏真机抓虫:手机上「点按钮」会先触发 blur,
                                     550→500 的修正与提示在同一个手势里被提交跳转吞掉。
                                     此旗 = 修正刚发生;下一次点击只亮红字不提交,再点才走。 */
      var sel = root.querySelector('[data-pts-input]'); /* 2026-08-12:档位下拉 → 自由输入框(变量名沿用 sel,避免大面积改动) */
      var btnRedeem = root.querySelector('[data-pts-redeem]');
      var btnCancel = root.querySelector('[data-pts-cancel]');
      /* D3 恢复按钮:不进 setBusy 列表 —— 409 后输入区保持灰(引导走取消),它必须独立可点 */
      var btnStale = root.querySelector('[data-pts-stale-cancel]');
      var msgEl = root.querySelector('[data-pts-msg]');
      var cap = parseInt(root.dataset.balance, 10) || 0;

      function showMsg(text) { if (msgEl) { msgEl.textContent = text; msgEl.hidden = false; } }
      function clearMsg() { if (msgEl) { msgEl.textContent = ''; msgEl.hidden = true; } }
      function setBusy(busy) {
        [btnRedeem, btnCancel, sel].forEach(function (el) { if (el) el.disabled = busy; });
      }
      /* 处理中反馈(2026-09-01 智鹏拍板):按钮换字+转圈。秒数不变,但"在干活"看得见 ——
         此前只静默变灰,3〜6 秒(建码+套码跳转)像卡死。所有失败/刹车路径必须复原。 */
      function setProcessing(btn, on) {
        if (!btn) return;
        if (on) {
          if (!btn.dataset.origLabel) btn.dataset.origLabel = btn.textContent;
          btn.textContent = L_BUSY;
          btn.classList.add('ayunel-points-redeem__btn--processing');
        } else {
          if (btn.dataset.origLabel) btn.textContent = btn.dataset.origLabel;
          btn.classList.remove('ayunel-points-redeem__btn--processing');
        }
      }

      /* ==== 「お手続き中」占位条(2026-09-04 事故修复,PR#552 搬入新房)====
         数据源 = /balance 的 pending[](**账本真相**),不是购物车里那张 AYPT 码。
         三条死律,一条都不能省(每条都是双脑复审两路独立点名的致命点):
         ① 取消按钮**绝不进 setBusy 名单**。余额 0 时(全额兑换后正是 0)下面的 available<=0
            分支会 setBusy(true);btnCancel 在那个静态数组里,取消按钮若同流合污 =
            「把门画上去、再锁上」。这里用【事件委托 + 动态节点】,天然不在数组里,与 btnStale 同款。
         ② 只有 cancelable 的行给按钮。pending_code(建码结果待查证)与已绑订单的不给 ——
            前者码可能真建成了、收敛必须走清扫批查证;后者归宿是 settle / orders/cancelled。
         ③ code 过白名单校验才进 DOM,全程 textContent/setAttribute,不拼 innerHTML。 */
      var CODE_RE = /^AYPT-\d+-[A-Z0-9]+$/;
      function renderPending(list) {
        var box = root.querySelector('[data-pts-pending-box]');
        if (!box) return;
        var items = [];
        for (var i = 0; i < (list || []).length; i++) {
          var p = list[i];
          if (p && Number(p.points) > 0 && CODE_RE.test(String(p.code || ''))) items.push(p);
        }
        box.textContent = '';
        if (!items.length) {
          box.hidden = true;
          markDedup(false);
          return;
        }
        for (var j = 0; j < items.length; j++) box.appendChild(pendingRow(items[j]));
        box.hidden = false;
        markDedup(true);
      }
      /* 🔑 2026-09-06 Codex 对抗审(高)后改:去重的条件不是「占位条可见」,而是
         **「购物车里这张码,在占位条里已经拿到一个可点的取消按钮」**。

         为什么不能只看占位条可见(原实现的洞,Codex 用内存 SQLite 跑源码查询复现过):
         /redeem/balance 的 pending 查询是 `ORDER BY redemption_id ASC LIMIT 10` —— **只回最老的 10 条**。
         客人若有 10 条已绑订单的老占位(cancelable:false,不给按钮)+ 1 张当前购物车里可取消的新码,
         那张新码根本不在返回里 ⇒ 占位条有文字、没有它的取消按钮,而下面又被隐藏
         ⇒ **客人失去取消当前这张码的唯一入口**(积分 = 钱)。
         同理还有:列表里全是别的码、当前码 cancelable:false、渲染中途出错。

         ⇒ 只在「找得到 data-code == 购物车当前码 的取消按钮」时才打标记;
            **任何不确定一律不打**,下面那两行照常显示兜底。 */
      function markDedup(hasRows) {
        var applied = (root.getAttribute('data-applied-code') || '').trim();
        var ok = false;
        if (hasRows && applied && CODE_RE.test(applied)) {
          ok = !!root.querySelector(
            '[data-pts-pending-cancel][data-code="' + applied + '"]'
          );
        }
        if (ok) {
          root.setAttribute('data-pts-dedup', '');
        } else {
          root.removeAttribute('data-pts-dedup');
        }
      }
      function pendingRow(p) {
        var wrap = document.createElement('div');
        wrap.className = 'ayunel-points-redeem__pending-row';
        var head = document.createElement('p');
        head.className = 'ayunel-points-redeem__pending-line';
        var note = document.createElement('p');
        note.className = 'ayunel-points-redeem__pending-note';
        /* ⚠️ 以下对客日语为**草案**,终审欠账未清(R7)。
           PR#552 是事故急修上线,「已上线」≠「已终审」—— 旧房原注释写的就是「草案,上线前必过
           brand-crm」,搬运时不许把这笔债写没了(2026-09-05 双脑复审 Agent 路点名)。
           本批 6 句 + 救援条 aria-label 均待 brand-crm 终审。 */
        /* ⚖️ 2026-09-06 brand-crm 二次终审:救援条那三句**不能整套搬到主卡**,逐条判过 ——
           · ordered:正文可用,但旧标题「ご利用予定」(将要用)配「完了」(已经用了)当场打架 → 换「ご注文に反映済み」;
           · processing:不含购物车前提,原样套用;
           · reserved:救援条那句「ご購入手続きが完了していないため」在救援条里是**解释反常**(空车却扣着分),
             搬到主卡就变成:她正站在购物车里、手指就在结账钮上方,却被告知「您的购买手续没有完成」——
             45–54 客群读到会以为刚才失败了,是在结账前一步制造疑虑、直接压 CVR。改成陈述常态。
           ⚠️ 标题不补金额:合计区已有独立的「ポイント利用 −¥N」行(2026-09-06 前台实测),
              再写一遍就是创始人嫌的那种重复;且 1ポイント=1円(站内两处文案坐实),不存在换算负担。 */
        if (p.state === 'ordered') {
          head.textContent = fmtPt(p.points) + 'ポイントをご注文に反映済み';     /* 已在订单中使用 N 积分 */
          note.textContent = 'ご注文時にお手続きが完了しております。';            /* 下单时已完成手续 */
        } else if (p.state === 'processing') {
          head.textContent = fmtPt(p.points) + 'ポイントをお手続き中';           /* N积分手续中 */
          note.textContent = 'ただいまお手続きを進めております。少々お待ちください。';  /* 正在办理,请稍候 */
        } else {
          head.textContent = fmtPt(p.points) + 'ポイントをご利用予定';           /* 预计使用 N 积分 */
          /* 「すぐに」= 線上規約 第2条第4項「直ちに残高へお戻しし」,**不承诺分钟数**。
             2026-09-06 核实:/redeem/cancel 成功路径里 releaseRedemption 是同步调用,余额当场回写,
             这四个字成立(失败路径走 deactivated_hold,已单独记 backlog)。 */
          note.textContent = 'ご注文が確定するまで、こちらのポイントはお預かりしています。取り消すと、すぐに残高へお戻しします。';
        }
        wrap.appendChild(head);
        wrap.appendChild(note);
        if (p.cancelable) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ayunel-points-redeem__btn ayunel-points-redeem__btn--outline ayunel-points-redeem__pending-cancel';
          b.setAttribute('data-pts-pending-cancel', '');
          b.setAttribute('data-code', p.code);
          b.textContent = '取り消して残高に戻す';                                /* 取消并退回余额 */
          wrap.appendChild(b);
        }
        return wrap;
      }
      function fmtDateJa(iso) { /* 'YYYY-MM-DD' → 'YYYY年M月D日'(绝对日期 JST,design-front §1.5) */
        var p = String(iso || '').split('-');
        if (p.length !== 3) return '';
        return parseInt(p[0], 10) + '年' + parseInt(p[1], 10) + '月' + parseInt(p[2], 10) + '日';
      }
      /* 千分位统一(2026-08-12):与 mypage 積分卡 toLocaleString('ja-JP') 对齐,
         同一个数字全站一种写法。Liquid 首屏不做格式化——登录态卡片在 JS 就绪前
         本就 opacity:0(见 stylesheet 防闪块),客户看到的一定是 JS 处理过的值。 */
      function fmtPt(n) {
        var v = Number(n);
        if (!isFinite(v)) return String(n);
        try { return v.toLocaleString('ja-JP'); } catch (e) { return String(v); }
      }
      /* 可提交的最大值 = cap 内最大的 UNIT 倍数(「すべて使う」走 useAll 才允许端数)。 */
      function maxUnitAmount(c) { return Math.floor((c || 0) / UNIT) * UNIT; }
      /* 输入吸附(2026-08-12 拍板的自由输入):去掉非数字 → 夹到上限 → 向下取整到 UNIT。
         客户永远提交不出会被 Worker 拒绝(`% UNIT !== 0`)的值:不弹错、直接把数字改对。 */
      function normalizeAmount(raw) {
        var digits = String(raw == null ? '' : raw).replace(/[^0-9]/g, '');
        if (!digits) return 0;
        var n = parseInt(digits, 10);
        if (!isFinite(n) || n <= 0) return 0;
        /* 2026-09-01「すべて使う」按钮删除(智鹏拍板)后的全额语义:输入 ≥ cap 一律
           吸到 cap 本身(允许端数,如 249);提交侧以 use_all 放行,与旧按钮完全等价。 */
        if (cap > 0 && n >= cap) return cap;
        if (cap > 0 && cap < UNIT) return cap; /* cap 不足1単位:任何正输入=全额端数(use_all 放行;2026-09-01 双审 #6) */
        var mx = maxUnitAmount(cap);
        if (n > mx) n = mx;
        var v = Math.floor(n / UNIT) * UNIT;
        /* 输入不足 1 単位(如 99)→ 吸到最低可用 100,而不是显示 0:
           客户的意图是「用一点点」,把它改成 0 既没帮上忙、看着又像坏了。
           只有当余额/购物车本身撑不到 100 时才落 0(此时控件已被 setBusy 灰掉)。 */
        if (v < UNIT && mx >= UNIT) v = UNIT;
        return v;
      }
      /* 原 rebuildOptions(重建档位下拉)已随下拉一起废弃;保留同名函数只做「刷新上限展示」,
         调用点不必改。newCap < UNIT(含余额 0)时清空输入框,由调用方 setBusy(true) 灰掉。 */
      function rebuildOptions(newCap) {
        if (!sel) return;
        sel.placeholder = newCap < UNIT ? String(UNIT) : String(maxUnitAmount(newCap));
        if (newCap < UNIT) sel.value = '';
      }
      function postJSON(path, body) {
        return fetch(PROXY_BASE + path, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(body || {})
        });
      }

      /* ---- 初始化:实时余额刷新(cart 页余额以 /balance 为准,镜像仅首屏快显) ---- */
      /* 🔑 2026-09-04 事故修复:balance 请求**提到 if 之外并共享**。
         原先整个请求包在 `if (btnRedeem)` 里 —— 於是「適用中カード」分支与「空车救援条」
         根本不发这个请求,占位信息永远拿不到、占位条永远不显示。而那两处恰恰是客人
         回来时看到的画面。只发一次,两个消费者各取所需(占位条 / 余额与档位)。 */
      var balancePromise = fetch(PROXY_BASE + '/balance', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('balance ' + r.status); return r.json(); });
      /* 占位条:与余额多少、有没有兑换表单、购物车里有没有那张码,全部无关 —— 只认账本。 */
      balancePromise
        .then(function (d) { renderPending(d && d.pending); })
        .catch(function () { /* 读不到就不显示占位条:没信息时不猜,保持现状(fail-closed 的显示侧) */ });

      if (btnRedeem) {
        setBusy(true);
        balancePromise
          .then(function (d) {
            /* 防御性取值:字段名以 Worker 实装为准(T-10 前占位) */
            var available = parseInt(d.available != null ? d.available : d.balance, 10);
            if (isNaN(available) || available < 0) throw new Error('balance shape');
            var balNum = root.querySelector('[data-pts-balance-num]');
            if (balNum) balNum.textContent = fmtPt(available);
            availableCache = available; /* cap 跟车刷新用(2026-08-27),余额不因车变、只存一次 */
            var cartTotal = lastTotalJpy !== null ? lastTotalJpy : (parseInt(root.dataset.cartTotal, 10) || 0);
            cap = Math.min(available, cartTotal); /* cap = min(available, cart 折后小计),design-redeem §2.1 */
            /* 🔴 2026-08-12 实撞的字段名不匹配:Worker 的 /redeem/balance 返回的是
               `expiring: [{points, expires_on}]`(数组,按 expires_on 升序 LIMIT 3),
               而这里原本读 `d.next_expiry` / `d.expiry` —— **两个都不存在,到期信息从来没读到过**。
               (接力档把响应字段列为「T-10 待实测占位」,当时只给 balance 做了 fallback,漏了到期。)
               取最近一笔(design-front §1.5:只显示最近到期,不做倒数)。 */
            var exp = null;
            if (d.next_expiry && d.next_expiry.points > 0) {
              exp = { points: d.next_expiry.points, date: d.next_expiry.date };
            } else if (d.expiring && d.expiring.length) {
              var e0 = d.expiring[0];
              if (e0 && e0.points > 0) exp = { points: e0.points, date: e0.expires_on };
            }
            var expEl = root.querySelector('[data-pts-expiry]');
            /* 🔴 2026-08-12 实撞:原写法只在「有到期信息」时覆盖,没有时**不清空** →
               Liquid 首屏渲染的【镜像】到期值会残留,与 JS 写入的【账本】实时余额打架,
               客户会看到「ご利用可能ポイント:0pt(うち 300pt は …まで)」这种自相矛盾。
               真实触发场景:客户积分刚失效/刚用光,镜像(15 分钟同步)还没跟上。
               死律:实时数据没有到期信息 = 必须清掉首屏残留,不能沿用镜像。 */
            if (expEl) {
              if (exp && exp.points > 0 && exp.date) {
                expEl.textContent = '(うち' + fmtPt(exp.points) + 'ポイントは' + fmtDateJa(exp.date) + 'まで)'; /* 2026-09-02 终审:半角括号=站内惯例,与首屏 Liquid 版一致 */
              } else {
                expEl.textContent = '';
              }
            }
            var ctrls = root.querySelector('[data-pts-controls]');
            var express = root.querySelector('[data-pts-express]');
            /* 🔑 2026-08-12 智鹏拍板:实时余额 0 **不再整段隐藏** —— 照实显示
               「ご利用可能ポイント:0pt」,让客户知道本店有积分制度。
               只收起点了会报错的操作区与指向它的说明行。卡片照常 .is-ready 淡入。 */
            if (available <= 0) {
              /* 智鹏 2026-08-12 二次拍板:0 分**不收起输入口**,只禁用 ——
                 「就算是 0 积分也要有输入的地方,要不然就像是坏的」。
                 rebuildOptions(0) 放 0pt 占位,setBusy(true) 灰掉下拉与两个按钮。 */
              rebuildOptions(0);
              setBusy(true);
              clearMsg();
              root.classList.add('is-ready');
              return;
            }
            if (ctrls) ctrls.hidden = false;
            if (express) express.hidden = false;
            rebuildOptions(cap);
            clearMsg();
            setBusy(false);
            root.classList.add('is-ready'); /* 确认有余额,淡入 */
            /* 2026-09-01 双审真雷(#6)已修:按钮时代此处禁输入、由「すべて使う」兜端数;
               按钮删除后再禁 = 1–99pt 客户唯一入口被焊死且永不解禁。现规则:cap>0 输入口
               保持可用,cap<100 的任意正输入由 normalizeAmount 吸到 cap(全额端数)。 */
          })
          .catch(function () {
            /* fail-closed:读不到实时余额就不放行兑换(涉钱宁停不赌);显示含糊错误。
               仍需 .is-ready —— 否则错误提示也停在 opacity:0,客户只会看到空白。 */
            showMsg(E_GENERIC);
            setBusy(true);
            root.classList.add('is-ready');
          });
      } else {
        /* ⚠️ 2026-09-05 更正:自 balancePromise 提到 if 外共享后,本分支**也会**拿到实时余额与占位明细
           (占位条正是靠它渲染);下面这段描述的是「不重建档位/不改余额显示」。原文保留:
           適用中カード分支:该分支只渲染 [data-pts-applied] + [data-pts-cancel],**没有**
           [data-pts-redeem],故不会走上面的实时余额查询。内容全部由 Liquid 直出,
           必须在此直接 .is-ready —— 否则卡片停在 opacity:0,客户看不到「利用中」与
           「取り消す」,等于把已适用积分的客户锁死。(2026-08-12 加防闪时当场堵掉的坑) */
        root.classList.add('is-ready');
      }

      /* ---- 全部使う:amount = cap(允许端数,P-11)。点了就把全额填进输入框,
             客户看得见自己要用多少,不是一个看不见的隐藏状态。 ---- */
      /* 输入中只挡非数字,吸附留到 blur —— 避免边打字边被改数,
         例如想输 1000 的人打到 "1" 就被改成 0。(「すべて使う」按钮已删,
         全额语义并入 normalizeAmount:输入 ≥ cap 即全额含端数。) */
      if (sel) sel.addEventListener('input', function () {
        var d = sel.value.replace(/[^0-9]/g, '');
        if (d !== sel.value) sel.value = d;
        clearMsg(); /* 客人开始改数字 = 上一条修正提示已过时 */
        pendingNotice = false;
      }, SIG);
      if (sel) sel.addEventListener('blur', function () {
        if (!sel.value) return;             /* 空着不动,交给提交时校验 */
        var typed = parseInt(String(sel.value).replace(/[^0-9]/g, ''), 10) || 0;
        var v = normalizeAmount(sel.value);
        sel.value = v ? String(v) : '';
        /* 修正即提示(智鹏 2026-09-01):数字被改了就说一声,不再默默改对 */
        if (v > 0 && typed > 0 && v !== typed) {
          showMsg(cap < UNIT || typed > cap ? M_CAP(v) : M_UNIT(v));
          pendingNotice = true;
        }
      }, SIG);

      /* ---- 兑换 ---- */
      if (btnRedeem) btnRedeem.addEventListener('click', function () {
        /* 2026-09-01 双审采纳(#1/#2):提交前现拉一次 /cart.js 重算 cap ——
           观察器只保展示层,碰钱时刻以此处现值为准;拉不动按现值继续
           (Worker 侧仍有 min(余额, points) 封顶 + settle 按实折坐实,方向安全)。 */
        setProcessing(btnRedeem, true);
        setBusy(true);
        fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; })
          .then(function (cc) {
            if (!cc || typeof cc.total_price !== 'number') {
              /* 2026-09-01 双审 H3:现拉失败改 fail-closed —— 原先吞掉继续按旧 cap 建码,
                 车缩水+网络抖动时会多锁积分(Worker 只按余额封顶,不按车额)。宁停不赌。 */
              setBusy(false);
              setProcessing(btnRedeem, false);
              showMsg(E_GENERIC);
              return;
            }
            capReqSeq++; /* 直读结果,作废在途的观察器刷新 */
            applyCartTotal(cc.total_price);
            setBusy(false);
            submitRedeem();
          });
      }, SIG);
      function submitRedeem() {
        var typed = parseInt(String((sel && sel.value) || '').replace(/[^0-9]/g, ''), 10) || 0;
        var amount = normalizeAmount(sel && sel.value);
        if (sel) sel.value = amount ? String(amount) : ''; /* 提交前把画面与实际提交值对齐 */
        /* 2026-09-01 智鹏拍板:输入不对 → 提示;这一次不提交。
           ① 空输入:亮 M_EMPTY,不再落含糊的 E_CHANGED;
           ② 数字被修正(单位取整/上限夹取,含提交前现拉后 cap 缩水的场合):
              亮对应提示 + 画面已是修正值,客人确认后再按一次才真扣 ——
              绝不拿与画面不一致的数字去锁积分(也顺手封死双审 #2 的"陈旧大数默默提交")。 */
        if (typed <= 0) { showMsg(M_EMPTY); setProcessing(btnRedeem, false); return; }
        if (amount > 0 && amount !== typed) {
          showMsg(cap < UNIT || typed > cap ? M_CAP(amount) : M_UNIT(amount));
          setProcessing(btnRedeem, false);
          return;
        }
        if (pendingNotice) { pendingNotice = false; setProcessing(btnRedeem, false); return; } /* 修正后的第一次点击:红字留在原地不提交(放在重算之后:cap 又变时上面会先亮新提示,2026-09-01 双审 M3) */
        var isUseAll = cap > 0 && amount === cap; /* 全额(可能含端数)→ use_all 放行;Worker 侧 min 封顶 */
        if (!amount || amount <= 0 || amount > cap) { showMsg(E_CHANGED); setProcessing(btnRedeem, false); return; }
        clearMsg();
        setBusy(true);
        /* 🔴 2026-08-12 真机实撞的契约错位(本 section 上线前的致命 bug):
             原本发的是 `{ amount }`,而 Worker 读的是 `req.points`(worker.js:1899)
             → 永远 undefined → `invalid_points` 400 → 前台只显示含糊错误,
             **兑换功能从来就没能成功过一次**。同类第三例(前两例:balance 的 `expiring`
             字段名、fetch 协议少斜杠)—— 根因都是「前端 JS 与 Worker 的契约从未端到端跑过」。
           「すべて使う」必须发 `use_all: true`:Worker 只在该标志下才放行端数
             (否则同样撞 `% UNIT !== 0`)。
           ✅ 2026-08-24 审查修复 D1/D2(原「已知口径缺口」结案):use_all 同时带上
             points = cap(按钮显示的 min(余额, 购物车额)那个数),Worker 侧
             Math.min(可花余额, points) 封顶 —— 按钮数字、实锁金额、码面额三者一致。
             cap 来自客户端只会把额度调小,不可信也无害;旧 Worker 忽略该字段照旧全额。 */
        postJSON('/create', isUseAll ? { use_all: true, points: amount } : { points: amount })
          .then(function (r) {
            /* 🔴 2026-08-26 审查修复 D4:409/422 原先不读 body 一律 throw 'changed' →
               active_redemption_exists(上次的码没套上车)也落「もう一度お選びください」,
               客户照做必然再 409 = 死循环。读 body.error 单独分流;body 读不出照旧 changed。 */
            if (r.status === 409 || r.status === 422) {
              return r.json().then(
                function (d) { throw new Error(d && d.error === 'active_redemption_exists' ? 'active' : 'changed'); },
                function () { throw new Error('changed'); }
              );
            }
            if (!r.ok) throw new Error('redeem ' + r.status);
            return r.json();
          })
          .then(function (d) {
            if (!d.code || String(d.code).indexOf('AYPT-') !== 0) throw new Error('shape');
            /* 套码方式:/discount/<CODE>?redirect=/cart(经验已验,家底 §6)→ 整刷回 cart 显示適用中 */
            window.location.href = '/discount/' + encodeURIComponent(d.code) + '?redirect=/cart';
          })
          .catch(function (e) {
            if (e && e.message === 'active') {
              /* D3:亮出「前回のお手続きを取り消す」。不走 30s 冷却恢复 —— Worker 在活动
                 兑换检查处就拒了、没进冷却计数;输入区保持灰是刻意的:改数字重试还是 409,
                 唯一出路是取消按钮(它不在 setBusy 列表,始终可点)。 */
              showMsg(E_ACTIVE);
              setProcessing(btnRedeem, false);
              if (btnStale) btnStale.hidden = false;
              return;
            }
            showMsg(e && e.message === 'changed' ? E_CHANGED : E_GENERIC);
            setProcessing(btnRedeem, false);
            /* 冷却结束后恢复可操作。原写法在 chosenAll 时把输入口再禁掉(下拉时代的遗留:
               选了「すべて使う」就锁死档位);换成自由输入框后不能锁 —— 失败重试的客户
               本来就该能改数字。2026-08-12 随下拉废弃一并去掉。 */
            setTimeout(function () { setBusy(false); }, COOLDOWN_MS);
          });
      }

      /* ---- D3 恢复动作:取消上次残留的兑换(码建了没套上车的死循环解锁) ----
         POST /cancel 空 body:Worker 按「该客最近一条 reserved」定位 —— 能撞 409 说明
         挡路的活码存在,且活码必是最新一条 reserved(建新码的前提是旧码已死、死码不复活),
         空 body 必中挡路那张。成功/404(已被清扫)都 reload 复位;失败保留按钮可重试。
         取消即时返还(worker.js:2827 智鹏拍板),reload 后余额已回、表单干净。 */
      if (btnStale) btnStale.addEventListener('click', function () {
        btnStale.disabled = true;
        clearMsg();
        postJSON('/cancel', {})
          .then(function (r) {
            if (r.status === 404) return null; /* 已经不活了 = 目的已达,照常复位 */
            if (!r.ok) throw new Error('cancel ' + r.status);
            return r.json();
          })
          .then(function () { window.location.reload(); })
          .catch(function () { showMsg(E_GENERIC); btnStale.disabled = false; });
      }, SIG);

      /* ---- cap 跟车刷新(2026-08-27 双脑复审两路一致点名):本 section 带
         data-skip-subtree-update,morph 不重渲染 → 改数量/装券删券后 cap 与
         「すべて使う」停留旧值(车缩水时能建出超车额码 —— 实折被 Shopify 封顶、
         差额由 settle_regrant 兜底不亏钱,但显示自相矛盾)。
         监听两个购物车事件,detail 里拿得到新车就用、拿不到现拉 /cart.js;
         只刷上限展示与「すべて使う」数字,不碰 available(余额不因车变)、
         不碰 disabled 状态机(busy/0余额/E_ACTIVE 态都不受影响)。 ---- */
      function applyCartTotal(totalCents) {
        lastTotalJpy = Math.round(totalCents / 100); /* 口径死律2:cart.js 金额除 100;balance 未回也先记 */
        if (availableCache === null) return;
        cap = Math.min(availableCache, lastTotalJpy);
        rebuildOptions(cap);
      }
      function onCartChanged(e) {
        void e; /* 事件通路在 4.1.4 已死(见下),统一现拉;签名保留 */
        var my = ++capReqSeq;
        fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (cc) {
            if (my !== capReqSeq) return; /* 旧响应不许盖新值(双审 #3 乱序) */
            if (cc && typeof cc.total_price === 'number') applyCartTotal(cc.total_price);
          })
          .catch(function () { /* 拿不到保持旧值;提交时刻另有现拉兜底 */ });
      }

      /* 🔴 2026-09-01 新房真机实测:4.1.4 的 cart:update / discount:update 到不了 document
         (数量 1→3 实变、morph 实发,七个候选事件名监听全部 0 次 —— 派发端随 morph 被
         换掉,冒泡断线;盘点档「事件换代」发现 3 成立)。改为 MutationObserver。
         双审(#4)后挂 document.body:__inner 等中层节点可能被 morph 整体替换 → 挂上面
         的观察器静默失联且 init 幂等锁挡住重绑;body 永不被换。root 内部变动忽略
         (showMsg 等自触发防环);300ms 防抖;仅兑换表单分支注册(適用中/无输入口不需要,
         双审 #3b 噪声)。展示层新鲜度尽力而为 —— 碰钱时刻的真值由提交前现拉保证。 */
      if (sel && typeof MutationObserver === 'function' && document.body && !root.__aypCapObs) {
        root.__aypCapObs = true; /* 单例(2026-09-01 双审):任何形式的重 init 都不再叠加观察器 */
        var capT = null;
        new MutationObserver(function (muts) {
          for (var i = 0; i < muts.length; i++) {
            if (!root.contains(muts[i].target)) {
              clearTimeout(capT);
              capT = setTimeout(function () { onCartChanged(null); }, 300);
              return;
            }
          }
        }).observe(document.body, { childList: true, subtree: true, characterData: true });
      }

      /* ---- 取消(统一入口,2026-09-04 事故修复搬入)----
         两个调用方:①適用中カード的「取り消す」(码还挂在购物车里时) ②占位条的
         「取り消して残高に戻す」(码已从购物车消失 / 空车时的唯一出路)。
         btn 为占位条按钮时,它**不受 setBusy 管**(死律①),失败要单独复原。 */
      function doCancel(code, btn) {
        return postJSON('/cancel', { code: code })
          .then(function (r) {
            /* 404 = 该兑换已经不活了(清扫批已释放 / 已被别处取消)。此时**不能 throw** ——
               原写法一 throw 就跳过下面的「从购物车移除码」,购物车里那张死码永远拿不掉,
               客户去 checkout 必失败,而且反复点取消永远是同一句错误。视同成功继续走。
               (2026-08-12 双脑复审两路一致指出的死胡同) */
            if (r.status === 404) return null;
            /* 🔴 2026-09-06 双脑复审(独立 Agent 高级)补:409 = cancel_race,这一笔已成定局。
               此前主卡只有 404 分支,409 掉进 catch 一律说「稍后再试」并放开按钮 →
               客人再点得 404 → 前端当成功静默 reload →「点了什么都没发生」。
               同样的画面在救援条上已被 brand-crm 判 CRITICAL,而主卡是**有货时的主路径**,
               触发面大一个量级 —— 修复此前只做了半边。 */
            if (r.status === 409) { var raceErr = new Error('cancel 409'); raceErr.aypRace = true; throw raceErr; }
            if (!r.ok) throw new Error('cancel ' + r.status);
            return r.json();
          })
          .then(function (body) {
            /* 🔴 2026-09-06:后端说「办好了」不等于「分退回来了」。released:false 的四条路径
               照样返回 200,此前被当成完全成功、全程静默。这里记一个跨刷新标记,
               刷新后由 renderHoldNotice 常驻显示一句说明。 */
            if (body && body.released === false) markHoldNotice();
            /* 🔴 2026-08-12 真机实撞:**停用 ≠ 从购物车拿掉**。
               /redeem/cancel 只在 Shopify 后台 deactivate 了折扣码,购物车里已套用的
               discount application 依然在 → 刷新后金额没变、卡片仍是「適用中」,
               客户完全看不出取消成功了,只会反复点(而那个码已经死了,去 checkout 会失败)。
               修法:显式从购物车移除。Cart AJAX API 的 discount 参数(2025-05 起支持)
               实测 200 且 cart_level_discount_applications 归零。 */
            /* 🔴 二次修正(2026-08-12 双脑复审两路一致):原本发 `{discount:''}`,
               而它的官方语义是「移除**全部**折扣」,不是「移除这一张」。客户若同时用着
               档期券/优惠码,取消积分会把别人的券一起删掉。
               正确做法:先读购物车现有码,滤掉 AYPT- 开头的,其余原样拼回去。 */
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
              .then(function (r) { return r.ok ? r.json() : null; })
              .then(function (c) {
                /* 🔴 2026-08-27 双脑复审(Codex 路)抓到的真 bug:/cart.js 瞬断时 c=null →
                   codes=[] → keep=[] → 发 discount:'' = 把客人的**其他券也清空** ——
                   正是 2026-08-12 二次修正要防的事在错误分支破防。
                   修:读不到购物车就【跳过】折扣清理(涉他人券,宁留死码不误删)——
                   下一步 reload 后页面显示真实状态,残挂的死码与既有 404 分支同路径收敛。 */
                if (!c || !Array.isArray(c.discount_codes)) return null;
                var codes = c.discount_codes;
                var keep = [];
                for (var i = 0; i < codes.length; i++) {
                  var cc = codes[i] && codes[i].code;
                  /* 🔴 2026-09-04 双脑复审两路一致:原判据是 `indexOf('AYPT-') !== 0`
                     = 踢掉**所有**积分码。2026-08-12 起同客可有多条 reserved 并存,
                     取消 A 会把还锁着分的 B 一起从购物车拿掉(B 的分仍锁在账本,
                     客人却看不到它被套用)。只踢**这一张**。 */
                  if (cc && cc !== code) keep.push(cc);
                }
                return fetch('/cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  credentials: 'same-origin',
                  body: JSON.stringify({ discount: keep.join(',') }),
                });
              })
              .then(function (r) {
                /* 4xx/5xx 不能当成功:静默失败会让客户刷新后又看到「適用中」而不知所措。
                   这里只留痕(下一步照常 reload,页面会显示真实状态),不阻断流程。 */
                if (r && !r.ok) console.log('ayp_cart_discount_remove_failed', r.status);
              })
              .catch(function () { /* 网络异常也继续:刷新后状态至少是新的,不把客户卡在原地 */ });
          })
          .then(function () {
            /* 🔴 原本显示「◯pt は60分以内に残高へ戻ります」并**等 60 秒**才刷新。
               智鹏 2026-08-12 实测后指出:客户输错想改,被告知等 60 分钟 = 直接流失。
               实况是**客户根本不用等** —— 锁定中的只有这一笔,剩余积分立刻可用
               (本次实测:1,500 中锁 400,余 1,100 当场可再兑)。
               故:立即刷新,让客户马上能重新输入;不再显示那句吓人的等待文案。
               ✅ 2026-09-04 已做:上面那条遗留(「/redeem/balance 增返 pending,前台标
                  ◯pt は処理中」)就是占位条 —— 现在客人无论从哪个画面回来,被锁的分都看得见、
                  也点得掉。(2026-09-05:搬进新房时漏改这句,双脑复审两路同时点名,已补。) */
            window.location.reload();
          })
          .catch(function (err) {
            var isRace = !!(err && err.aypRace);
            showMsg(isRace ? E_RACE : E_GENERIC);
            /* 409 之后**不复原被点的那颗**(再点只会拿到 404 → 被当成功静默 reload);
               其余可重试的失败照常复原。 */
            if (!isRace) setProcessing(btn || btnCancel, false);
            /* 🔴 2026-09-05 双脑复审两路一致:失败恢复**必须按调用方分支**。
               原写法无条件 setBusy(false) —— 余额 0 时(全额兑换后正是 0)初始化本就
               setBusy(true) 把兑换区灰着,占位取消一失败就把输入框与「利用する」一起解禁,
               客人接着撞 Worker 的拒绝。方向上是 fail-open,与本卡通篇 fail-closed 相反。
               现在:静态取消(btn=null)才复原 setBusy;占位取消只复原自己那颗按钮。 */
            if (btn) {
              cancelling = false;
              var all = root.querySelectorAll('[data-pts-pending-cancel]');
              /* ⚠️ 只锁冲突的这一笔:其余笔与本次冲突无关,必须放开 ——
                 否则取消 A 撞 409 会连带锁死同页 B,客人非刷新不可
                 (Codex 对抗审 2026-09-06 中级,源码模拟复现)。 */
              for (var i = 0; i < all.length; i++) {
                if (isRace && all[i] === btn) continue;
                all[i].disabled = false;
              }
            } else if (!isRace) {
              setBusy(false);
            }
          });
      }

      /* 调用方①:適用中カード的「取り消す」—— 码还挂在购物车里时的原有入口,行为不变 */
      if (btnCancel) btnCancel.addEventListener('click', function () {
        var code = root.dataset.appliedCode || '';
        if (!code) return;
        setProcessing(btnCancel, true);
        setBusy(true);
        doCancel(code, null);
      }, SIG);

      /* 调用方②:占位条的「取り消して残高に戻す」(2026-09-04 事故修复)。
         事件委托 —— 节点由 renderPending 动态生成(可能多条);且**刻意绕开 setBusy**:
         余额 0 时 setBusy(true) 会灰掉静态名单里的控件,这个按钮必须始终可点(死律①)。 */
      /* 取消互斥锁(2026-09-05 Codex 路点名):同客可有多条占位,连续点两条时两条流程都会
         「读整车折扣 → 改整份列表」,后完成的会把先取消的那张码原样写回购物车(丢失更新)。
         账本侧按精确 code 操作是安全的,但购物车会残留已停用的死码 ⇒ 一次只放行一笔。
         ⚠️ 刻意**不并入 setBusy** —— 那个名单在余额 0 时是常灰的,并进去就等于按钮永远点不动。 */
      var cancelling = false;
      root.addEventListener('click', function (e) {
        var b = e.target && e.target.closest ? e.target.closest('[data-pts-pending-cancel]') : null;
        if (!b || b.disabled || cancelling) return;
        var code = b.getAttribute('data-code') || '';
        if (!CODE_RE.test(code)) return;
        cancelling = true;
        var all = root.querySelectorAll('[data-pts-pending-cancel]');
        for (var i = 0; i < all.length; i++) all[i].disabled = true;
        setProcessing(b, true);
        clearMsg();
        doCancel(code, b);
      }, SIG);
  }

  /* 初始化时机(§0.10:禁 setTimeout 兜底链):DOM ready 跑一次;之后用 MutationObserver
     + 80ms debounce 兜 PJAX/morph 后的重新渲染(section 带 data-skip-subtree-update,
     cart 内更新不会重建它,故实际触发极少;init 自身有 aypInit 幂等锁)。 */
  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(initPointsRedeem, 80); }

  /* 🔴 2026-08-12 真机实撞:原写法把 observer 注册放在顶层、以 `&& document.body` 做守卫。
     javascript 标签 打包出的 bundle 在 <body> 存在之前执行时,document.body 为 null →
     **observer 静默不注册**,「PJAX/morph 后重新初始化」这条兜底实际上是死的
     (实测:往 body 追加节点后 initPointsRedeem 一次都没被调用)。
     修法:把注册与首次 init 一起挂到 DOM ready 之后,保证 document.body 必然存在。 */
  function setupObserver() {
    if (typeof MutationObserver !== 'function' || !document.body) return;
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  function boot() { initPointsRedeem(); setupObserver(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ayunel-points-rescue"] && !Shopify.designMode) return;
  try {
    /* AYUNEL 积分救援条 — 无外部依赖,纯 vanilla。
     与主卡(ayunel-points-redeem)**互斥渲染**:主卡只在有商品时出现,本条只在空车/只剩赠品时出现,
     故两者的 JS 永不同时活跃,选择器与幂等锁各自独立、互不干扰。 */
  (function () {
    'use strict';

    var CODE_RE = /^AYPT-\d+-[A-Z0-9]+$/;
    /* 対客文案:brand-crm 2026-09-06 终审済。⚠️ E_GENERIC 已按本条语境(取消失败)改写,
       **与主卡的同名常量不再逐字同源** —— 主卡那句讲的是兑换失败,两边不许互抄。中文对照见行尾。 */
    /* 503 / 网络错误 / 解析失败 —— 后端 fail-closed 不改任何状态,积分确实仍锁在那张活码上。 */
    var E_GENERIC = '恐れ入ります。ただいま取り消しのお手続きができませんでした。ポイントはそのままの状態で残っておりますので、少し時間をおいてからもう一度お試しください。';  /* 取消手续未完成;积分维持原样保留,请稍后再试 */
    /* 🔴 409 = 后端 cancel_race:`UPDATE … WHERE status='reserved'` 影响 0 行。
       ⚠️ 2026-09-06 双脑复审更正:409 **不等于**「积分已被这单用掉」。`reserved` 变走有三条路 ——
          committed(真的变成了这单折扣)/ released(清扫批已释放、积分早退回余额了)/ late_settled。
          前端拿到 409 分不出是哪种,所以文案**一句去向都不能断言**(上一版说「已作为折扣反映,
          请到订单履历确认」,在 released 时是让客人去找一笔不存在的抵扣)。
       文案 brand-crm 2026-09-06 二次终审:只陈述 409 唯一能确定的事实(那行占位已经不在了),
       用「お預かりを終えており」与 reserved 态的「お預かりしています」咬合成同一套词;
       给两个自查出口(先余额后订单履历 —— 主卡语境下她还没下单,先看订单履历会懵)。
       主卡与救援条**共用同一句**(brand-crm:同一错误两处措辞不同,客人截图问客服会以为是两种问题)。 */
    var E_RACE = '恐れ入ります。入れ違いで、こちらのポイントはすでにお預かりを終えており、取り消しのお手続きができませんでした。ポイントが失われることはございませんので、マイページのポイント残高、またはご注文履歴から、今の状態をご確認いただけます。';  /* 取消未能办理;积分不会消失,可在积分余额或订单履历确认 */

    function initPointsRescue() {
      var root = document.querySelector('[data-pts-rescue]');
      /* 幂等锁存 JS property 而非 dataset:morph 的 copyAttributes 会剥 data-* 属性,
         用 property 才能在「节点保留」时真正挡住重复初始化(与主卡同款处置)。 */
      if (!root || root.__aypRescueInit) return;
      root.__aypRescueInit = true;

      var PROXY_BASE = root.dataset.proxyBase || '/apps/points';
      var box = root.querySelector('[data-pts-pending-box]');
      var msgEl = root.querySelector('[data-pts-msg]');
      /* 取消互斥锁(2026-09-05 Codex 路点名):同客可有多条占位,连续点两条时
         两条流程都会「读整车折扣 → 改整份列表」,后完成的会把先取消的那张码带回购物车。
         账本侧按精确 code 操作是安全的,但购物车会出现已停用的死码 ⇒ 一次只放行一笔。 */
      var cancelling = false;

      function showMsg(t) { if (msgEl) { msgEl.textContent = t; msgEl.hidden = false; } }
      function clearMsg() { if (msgEl) { msgEl.textContent = ''; msgEl.hidden = true; } }
      function fmtPt(n) {
        var v = Number(n);
        if (!isFinite(v)) return String(n);
        try { return v.toLocaleString('ja-JP'); } catch (e) { return String(v); }
      }

      function pendingRow(p) {
        var wrap = document.createElement('div');
        wrap.className = 'ayunel-points-rescue__row';
        var head = document.createElement('p');
        head.className = 'ayunel-points-rescue__line';
        var note = document.createElement('p');
        note.className = 'ayunel-points-rescue__note';
        if (p.state === 'ordered') {
          head.textContent = fmtPt(p.points) + 'ポイントをご利用予定';           /* N积分预定使用 */
          note.textContent = 'ご注文時にお手続きが完了しております。';            /* 下单时手续已完成 */
        } else if (p.state === 'processing') {
          head.textContent = fmtPt(p.points) + 'ポイントをお手続き中';           /* N积分手续中 */
          note.textContent = 'ただいまお手続きを進めております。少々お待ちください。';  /* 正在办理,请稍候 */
        } else {
          head.textContent = fmtPt(p.points) + 'ポイントをお手続き中';
          /* 口径对齐線上規約 第2条第4項「直ちに残高へお戻しし」——不承诺具体分钟数 */
          note.textContent = 'ご購入手続きが完了していないため、こちらのポイントは一時的にお預かりしています。取り消すと、すぐに残高へお戻しします。';  /* 购买手续未完成,该部分积分暂由我方保管;取消后立即退回余额 */
        }
        wrap.appendChild(head);
        wrap.appendChild(note);
        if (p.cancelable) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ayunel-points-rescue__btn';
          b.setAttribute('data-pts-pending-cancel', '');
          b.setAttribute('data-code', p.code);
          b.textContent = '取り消して残高に戻す';                                /* 取消并退回余额 */
          wrap.appendChild(b);
        }
        return wrap;
      }

      function renderPending(list) {
        if (!box) return;
        var items = [];
        for (var i = 0; i < (list || []).length; i++) {
          var p = list[i];
          /* code 过白名单才进 DOM;全程 textContent/setAttribute,不拼 innerHTML */
          if (p && Number(p.points) > 0 && CODE_RE.test(String(p.code || ''))) items.push(p);
        }
        box.textContent = '';
        if (!items.length) {
          box.hidden = true;
          root.hidden = true;   /* 没有占位 ⇒ 完全不出现,空车页干干净净 */
          return;
        }
        for (var j = 0; j < items.length; j++) box.appendChild(pendingRow(items[j]));
        box.hidden = false;
        root.hidden = false;
      }

      /* 只读:查账本有没有锁着的分。读不到就保持隐藏(没信息时不猜) */
      fetch(PROXY_BASE + '/balance', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('balance ' + r.status); return r.json(); })
        .then(function (d) { renderPending(d && d.pending); })
        .catch(function () { /* fail-closed 的显示侧:查不到就不显示 */ });

      /* 取消:事件委托(节点动态生成,可能多条)。互斥锁保证一次只走一笔。 */
      root.addEventListener('click', function (e) {
        var b = e.target && e.target.closest ? e.target.closest('[data-pts-pending-cancel]') : null;
        if (!b || b.disabled || cancelling) return;
        var code = b.getAttribute('data-code') || '';
        if (!CODE_RE.test(code)) return;
        cancelling = true;
        clearMsg();
        /* 取消期间禁用**全部**取消按钮,而不只是被点的那个 —— 见 cancelling 的注释 */
        var all = root.querySelectorAll('[data-pts-pending-cancel]');
        for (var i = 0; i < all.length; i++) all[i].disabled = true;

        fetch(PROXY_BASE + '/cancel', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ code: code })
        })
          .then(function (r) {
            /* 404 = 该兑换已经不活了(清扫批已释放 / 别处已取消)。视同成功,继续走刷新 ——
               不能 throw,否则客户反复点、永远看到同一句错误(旧房 2026-08-12 踩过)。 */
            if (r.status === 404) return null;
            /* 409 = cancel_race:积分已被本单用掉(见上方 E_RACE 注释)。单独标记,走不同文案 + 不重启按钮。 */
            if (r.status === 409) { var raceErr = new Error('cancel 409'); raceErr.aypRace = true; throw raceErr; }
            if (!r.ok) throw new Error('cancel ' + r.status);
            return r.json();
          })
          .then(function () {
            /* 空车场景购物车里本就没有这张码可摘(cart 已空 / 只剩赠品),
               故不需要主卡那套 /cart/update.js 折扣清理。直接刷新看真实状态。 */
            window.location.reload();
          })
          .catch(function (err) {
            var isRace = !!(err && err.aypRace);
            showMsg(isRace ? E_RACE : E_GENERIC);
            cancelling = false;
            /* 409 之后**只锁住冲突的这一笔**:它已成定局,再点只会拿到 404 → 被当成功静默 reload,
               客人看到「点了但什么都没发生」(brand-crm 2026-09-06 发现③)。
               ⚠️ 但其余笔与本次冲突无关,必须放开 —— 原写法整个 for 跳过,取消 A 撞 409
               会连带锁死同页 B 的按钮,客人非刷新不可(Codex 对抗审 2026-09-06 中级,源码模拟复现)。
               其余失败(503 / 网络)整批可重试,照常全放开。 */
            for (var k = 0; k < all.length; k++) {
              if (isRace && all[k] === b) continue;
              all[k].disabled = false;
            }
          });
      });
    }

    /* 初始化时机(§0.10:禁 setTimeout 兜底链):DOM ready 跑一次;
       之后用 MutationObserver + 80ms debounce 兜 morph 后的重新渲染。
       observer 挂 body 且全局单例,避免节点换代后累积(2026-09-05 Codex 路点名主卡的同类问题)。 */
    var t = null;
    function schedule() { clearTimeout(t); t = setTimeout(initPointsRescue, 80); }
    function setupObserver() {
      if (typeof MutationObserver !== 'function' || !document.body) return;
      if (document.body.__aypRescueObs) return;
      document.body.__aypRescueObs = true;
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
    function boot() { initPointsRescue(); setupObserver(); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
